import type { ReactNode } from 'react';
import type { IHsdqQuestionnaireCustomControlData } from '../../../../../../common/validation/customControls/somnology';
import type { IQuestionnaireFormProps } from '../../Questionnaire';
import { BackButton } from '../../../../elements/atoms/backButton/BackButton';
import { Main } from '../../../../elements/molecules/main/Main';
import { ProgressBar } from '../../../../elements/molecules/progressBar/ProgressBar';
import { Footer } from '../../../../elements/organisms/footer/Footer';
import { Header } from '../../../../elements/organisms/header/Header';
import { PageWrapper } from '../../../../elements/organisms/pageWrapper/PageWrapper';
import { Intro } from './steps/Intro';
import { Step1 } from './steps/Step1';
import { Step2 } from './steps/Step2';
import { Step3 } from './steps/Step3';
import { Step4 } from './steps/Step4';
import { Step5 } from './steps/Step5';
import { Step6 } from './steps/Step6';
import { Step7 } from './steps/Step7';

export interface IHsdqQuestion {
    key: keyof IHsdqQuestionnaireCustomControlData;
    label: string;
    number: number;
}

export function NewHsdqQuestionnaire(props: IQuestionnaireFormProps) {
    const steps: ReactNode[] = [
        <Intro
            key={0}
            {...props}
        />,
        <Step1
            key={1}
            {...props}
        />,
        <Step2
            key={2}
            {...props}
        />,
        <Step3
            key={3}
            {...props}
        />,
        <Step4
            key={4}
            {...props}
        />,
        <Step5
            key={5}
            {...props}
        />,
        <Step6
            key={6}
            {...props}
        />,
        <Step7
            key={7}
            {...props}
            submit={props.validateAndSubmitQuestionnaire}
        />,
    ];

    const backButton = <BackButton goBackFunction={props.goToPrevStep} />;

    return (
        <PageWrapper
            fullHeight
            scrollToTopUpdater={props.currentStep}
        >
            <Header
                customBackButton={backButton}
                hasBackbutton
            />
            {props.currentStep > 0 && props.currentStep < steps.length - 1 && (
                <ProgressBar progress={(props.currentStep / (steps.length - 1)) * 100}></ProgressBar>
            )}
            <Main>{props.currentStep >= 0 && props.currentStep < steps.length && steps[props.currentStep]}</Main>
            <Footer />
        </PageWrapper>
    );
}
